import { Component } from 'react';
import '../../../../styles/components/auth.scss';
import { ArrowLeft, Loader2, MoveRight, UserRound } from 'lucide-react';
import { withRouter } from '../../../../hoc/withRouter';
import { forgotPassword } from './services/authService';
import { toast } from 'react-toastify';
import i18n from '../../../../i18n';

class ForgotPasswordNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: null,
      errors: {},
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  validateForm = () => {
    const errors = {};
    const { email } = this.state;
    if (!email) errors.email = 'email is required';
    if (email && !/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Invalid email format';
    }

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  };

  renderFieldError = (fieldName) => {
    if (this.state.errors[fieldName]) {
      return <div className="field-error">{this.state.errors[fieldName]}</div>;
    }
    return null;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.validateForm()) {
      return;
    }
    const { email } = this.state;
    console.log('Login submitted:', this.state);
    // Add your login logic here
    this.setState({ isSubmitting: true });
    try {
      const result = await forgotPassword({
        email: email,
      });

      const { response } = result;
      // Check if verification is required (OTP/email)

      if (response?.data?.requires_verification) {
        this.props.navigate(`/login/otp-verify-email/${response.data.verification_token}`, {
          state: {
            data: response.data.email,
            type: 'email',
          },
        });
        return;
      }

      toast.success(response?.message || 'forgot Password successful!');

      this.props.navigate(`/forgot-password-confirmation`);
    } catch (error) {
      toast.error(error.message || 'forgot Password failed. Please try again.');
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handleBack = () => {
    console.log('Going back...');
    this.props.navigate(`/login`);
  };
  render() {
    const { email, errors, isSubmitting } = this.state;

    return (
      <div className="register-container">
        <div className="login-left-section">
          <div className="auth-content">
            <div className="accent-line"></div>
            <h1 className="title">
              {i18n.t('login_banner_title')}{' '}
              <span className="highlight-l2">{i18n.t('login_banner_title_b')}</span>,{' '}
              {i18n.t('login_banner_title_c')}
            </h1>
            <p className="subtitle-l2">{i18n.t('login_banner_subtitle')}</p>
          </div>
        </div>

        <div className="login-right-section">
          <div className="login-card">
            <button onClick={this.handleBack} className="back-button">
              <ArrowLeft size={20} strokeWidth={1.5} />
              <span> {i18n.t('back')}</span>
            </button>
            <h3 className="welcome-title">{i18n.t('forgot_password')}</h3>
            <p className="welcome-subtitle">{i18n.t('forgot_password_card_subtitle')}</p>

            <form onSubmit={this.handleSubmit}>
              <div className="form-group-l2">
                <label htmlFor="email">{i18n.t('email_address')}</label>
                <div className="input-wrapper">
                  <UserRound strokeWidth={1.5} className="input-icon-l2" />
                  <input
                    type="text"
                    id="email"
                    name="email"
                    value={email}
                    onChange={this.handleInputChange}
                    placeholder={i18n.t('validate_email')}
                    className={`form-input-l2 ${errors?.email ? 'error' : ''}`}
                  />
                </div>
                {this.renderFieldError('email')}
              </div>
              <div className="form-links"></div>

              <button type="submit" disabled={isSubmitting} className="button1 button1-gradient ">
                {i18n.t('continue')}
                {isSubmitting ? (
                  <Loader2 className="animate-spin" size={18} />
                ) : (
                  <MoveRight strokeWidth={1.5} />
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ForgotPasswordNew);
